/**
 * Centralized application configuration.
 *
 * All environment variables are read here so the rest of the codebase
 * imports from this module instead of accessing import.meta.env directly.
 * When migrating to Nuxt 4, only this file needs to switch to runtimeConfig.
 */

const env = import.meta.env;

export const config = {
    api: {
        baseURL: env.VUE_APP_API_BASE_URL,
        timeout: 70000,
    },

    app: {
        baseURL: env.VUE_APP_BASE_URL,
        basePath: env.BASE_URL || '/',
        version: env.VUE_APP_VERSION,
        autoUpdate: env.VUE_APP_AUTOUPDATE === 'true',
        showProductionAlert: env.VUE_APP_SHOW_PRODUCTION_ALERT,
        mode: env.MODE,
        isProd: env.PROD,
        isDev: env.DEV,
    },

    account: {
        url: env.VUE_APP_ACCOUNT_URL,
        gatewayURL: env.VUE_APP_ACCOUNT_GATEWAY_URL,
    },

    auth: {
        cookieName: env.VUE_APP_AUTH_COOKIE_NAME,
    },

    functions: {
        baseURL: env.VUE_APP_FUNC_URL,
    },

    pusher: {
        appKey: env.VUE_APP_PUSHER_APP_KEY,
        cluster: env.VUE_APP_PUSHER_CLUSTER,
        authEndpoint: env.VUE_APP_PUSHER_AUTH_ENDPOINT,
    },

    sentry: {
        dsn: env.VUE_APP_SENTRY_DSN,
    },

    stripe: {
        publicKeyTest: env.VUE_APP_STRIPE_PUBLIC_KEY_TESTMODE,
        publicKeyLive: env.VUE_APP_STRIPE_PUBLIC_KEY_LIVEMODE,
    },

    turnstile: {
        siteKey: env.VUE_APP_TURNSTILE_SITEKEY,
    },

    survey: {
        url: env.VUE_APP_SURVEY_URL,
    },
};
